var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircleCheckmark = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_2",
    viewBox: "0 0 618.7 618.7",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m309.35,618.7C138.77,618.7,0,479.92,0,309.35S138.77,0,309.35,0s309.35,138.77,309.35,309.35-138.77,309.35-309.35,309.35Zm0-586.26c-152.69,0-276.91,124.22-276.91,276.91s124.22,276.91,276.91,276.91,276.91-124.22,276.91-276.91S462.03,32.44,309.35,32.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.68,456.52h0c-8.6,0-16.86-3.42-22.94-9.5l-122.11-122.11c-12.67-12.67-12.67-33.21,0-45.88,12.67-12.67,33.21-12.67,45.88,0l99.17,99.17,206.51-206.51c12.67-12.67,33.21-12.67,45.88,0,12.67,12.67,12.67,33.21,0,45.88l-229.45,229.45c-6.08,6.08-14.34,9.5-22.94,9.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleCheckmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle_checkmark.449b5d2b.svg";
export { ForwardRef as ReactComponent };